import { h } from 'preact';
import { useStore } from 'src/hooks';
import * as styles from './styles.less';

const SidebarScreenname = () => {
    const ctx = useStore();
    return (
        <div class={styles.screenname}>
            <b>{ctx.user.screenName}</b>
        </div>
    );
};

export default SidebarScreenname;
